/** Current version of the shared domain contract. */
export const DOMAIN_VERSION = '0.0.0';
